var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, IconButton, Typography, styled, Tooltip } from '@mui/material';
import { BuildCircle, Menu as MenuIcon } from '@mui/icons-material';
import React, { useContext } from 'react';
import { MenuList } from './MenuList';
import SwitchThemeButton from './SwitchThemeButton';
import { MadboxAppContext } from './Template';
export var drawerWidthOpen = 320;
export var drawerWidthClosed = 82;
var MenuContainer = styled('div')(function (_a) {
    var _b;
    var theme = _a.theme, open = _a.open;
    return (_b = {
            display: 'flex',
            flexDirection: 'column',
            zIndex: 1,
            borderRightColor: theme.palette.border,
            borderRightStyle: 'solid',
            borderRightWidth: 1,
            minWidth: open ? drawerWidthOpen : drawerWidthClosed,
            width: open ? drawerWidthOpen : drawerWidthClosed
        },
        _b[theme.breakpoints.down('md')] = {
            width: open ? drawerWidthOpen : 0,
            minWidth: open ? drawerWidthOpen : 0,
        },
        _b.height = '100%',
        _b.overflow = 'hidden',
        _b);
});
var MenuIconContainer = styled(Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            padding: theme.spacing(4)
        },
        _b[theme.breakpoints.down('md')] = {
            padding: theme.spacing(2),
            paddingTop: theme.spacing(1),
        },
        _b.display = 'flex',
        _b.alignItems = 'center',
        _b);
});
export var Menu = React.memo(function (props) {
    var open = props.open, setOpen = props.setOpen;
    var _a = useContext(MadboxAppContext), themeMode = _a.themeMode, setThemeMode = _a.setThemeMode, devMode = _a.devMode, setDevMode = _a.setDevMode, allowDevMode = _a.allowDevMode, version = _a.version;
    return (_jsxs(MenuContainer, __assign({ open: open }, { children: [_jsxs(MenuIconContainer, { children: [_jsx(IconButton, __assign({ onClick: function () { return setOpen(!open); }, edge: "start" }, { children: _jsx(MenuIcon, {}, void 0) }), void 0), open && (_jsx(IconButton, __assign({ href: "https://admin.madbox.io", sx: { borderRadius: 1, marginLeft: 2 } }, { children: _jsx("img", { src: "https://s3.eu-west-1.amazonaws.com/altaria-bucket.madboxgames.io/icons/madbox_full.svg", height: 20, alt: "Madbox" }, void 0) }), void 0))] }, void 0), _jsx(MenuList, { open: open, setOpen: setOpen }, void 0), open && (_jsx(_Fragment, { children: _jsxs(MenuIconContainer, { children: [allowDevMode ? (_jsx(Tooltip, __assign({ title: "Toggle developer mode" }, { children: _jsx(IconButton, __assign({ onClick: function () { return setDevMode(!devMode); } }, { children: _jsx(BuildCircle, { color: devMode ? 'primary' : 'disabled' }, void 0) }), void 0) }), void 0)) : null, _jsxs(Typography, __assign({ variant: "caption", color: "gray" }, { children: [window.location.hostname.replace('.madbox.io', ''), " v", version] }), void 0), _jsx(SwitchThemeButton, { sx: { marginLeft: 'auto' }, checked: themeMode === 'dark', onChange: function (e, checked) { return setThemeMode(checked ? 'dark' : 'light'); } }, void 0)] }, void 0) }, void 0))] }), void 0));
});
